import React, { useEffect, useState } from "react";
import Layout from "../../components/layout/Layout";
import Counters from "../../components/common/Counters";
import { ToastContainer } from "react-toastify";
import { connect, useDispatch, useSelector } from "react-redux";
import { reportList } from "../../redux/action/report";
import { contactList } from "../../redux/action/contact";
import {
  ordersList,
  recentDelete,
  recentOrders,
} from "../../redux/action/order";
import dateFormat from "dateformat";
import { fleetList } from "../../redux/action/fleet";
import { staffList } from "../../redux/action/staff";
import { Link } from "react-router-dom";
import RecentOrderView from "./../order/RecentOrderView";
import Pagination from "./../../components/Pagination";
import { io } from "socket.io-client";
import axios from "axios";
import { CSVLink } from "react-csv";
import { APIURL, SOCETCONNURL } from "../../redux/action/config";
import loader from "../../components/loader/loader";
import CancelOrder from "../order/CancelOrder";

const Dashboard = ({ OrdersNotFound }) => {
  const headers = [
    { label: "Name", key: "name" },
    { label: "Email Address", key: "email" },
    { label: "Phone Number", key: "phone" },
    { label: "Message", key: "message" },
  ];

  const [productDataList, setProductDataList] = useState([]);
  const onChangePage = (pageOfItems) => {
    setProductDataList(pageOfItems);
  };
  const [contacts, setContacts] = useState([]);
  const [orders, setOrders] = useState([]);
  const [allOrders, setallOrders] = useState([]);
  const [allReports, setallReports] = useState([]);
  const [cancelOrderId, setCancelOrderId] = useState(null);
  const [oData, setOData] = useState();

  // Recent Orders
  const [id, setId] = useState();
  const reports = useSelector((state) => state.report.list.data);
  const orderList = useSelector((state) => state.order.new_orders);
  const FleetData = useSelector((state) => state.fleet.list);
  const StaffData = useSelector((state) => state.staff.list);
  const dispatch = useDispatch();

  useEffect(() => {
    const getRecentOrders = () => {
      dispatch(ordersList());
    };
    getRecentOrders();
  }, []);

  useEffect(() => {
    setOrders(orderList);
  }, [orderList]);

  useEffect(() => {
    const socket = io(SOCETCONNURL);

    socket.on("contact-added", (items) => {
      setContacts(items);
    });
    socket.on("order-list", (items) => {
      setOrders(items?.splice(0, 5));
      setallOrders(items);
      dispatch(staffList());
    });

    socket.on("all-reports", (items) => {
      setallReports(items);
    });
    socket.on("disconnect", () => {
      console.log("Socket disconnecting");
    });
  }, []);

  useEffect(() => {
    dispatch(staffList());
    dispatch(reportList());
    dispatch(contactList());
  }, [dispatch]);

  const recentOrder = orders ? orders?.slice(0, 5) : "";

  const recentDel = (id) => {
    dispatch(recentDelete(id));
    setTimeout(() => {
      dispatch(ordersList());
      dispatch(reportList());
    }, 1000);
  };
  //
  const report = useSelector((state) => state?.report?.list);

  const contact = useSelector((state) => state?.contact?.list);

  const messageList = contact?.data?.contact ? contact?.data?.contact : "";

  const totalBalance = allOrders
    ? allOrders?.reduce((acc, item) => {
        return acc + Number(item?.amount ? item?.amount : 0);
      }, 0)
    : "";
  const recentOrderStatus = (status) => {
    switch (status) {
      case "order_initiated":
        return "Order Initiated";
      case "order_placed":
        return "Order Placed";
      case "order_in_progress":
        return "Order In Progress";
      case "order_completed":
        return "Completed";
      case "order_canceled":
        return "Order Canceled";
      default:
    }
  };
  const recentOrderColor = (status) => {
    switch (status) {
      case "order_initiated":
        return "badge-light-dark";
      case "order_placed":
        return "badge-light-info";
      case "order_in_progress":
        return "badge-light-warning";
      case "order_completed":
        return "badge-green";
      case "order_canceled":
        return "badge-light-danger";
      default:
    }
  };

  const taskStatus = (status) => {
    switch (status) {
      case "n/a":
        return "Staff will assigned soon";
      case "staff_assigned":
        return "Staff assigned";
      case "reached_at_location":
        return "Staff reached at location";
      case "setting_safety_items":
        return "Setting safety items";
      case "access_situation":
        return "Access situation";
      case "rectifiying_problem":
        return "Rectifiying problem";
      case "towing_required":
        return "Towing required";
      case "task_completed":
        return "Completed";
      default:
    }
  };
  const taskStatusColor = (status) => {
    switch (status) {
      case "n/a":
        return "badge-light-dark";
      case "staff_assigned":
        return "badge-light-info";
      case "reached_at_location":
        return "badge-light-dark";
      case "setting_safety_items":
        return "badge-light-info";
      case "access_situation":
        return "badge-light-warning";
      case "rectifiying_problem":
        return "badge-light-info";
      case "towing_required":
        return "badge-light-danger";
      case "task_completed":
        return "badge-green";
      default:
    }
  };

  const [loading, setLoading] = React.useState(true);
  setTimeout(() => {
    setLoading(false);
  }, 2000);

  return (
    <React.Fragment>
      <ToastContainer autoClose={2000} />
      <Layout title="Dashboard" page="dashboard">
        <div
          className="content d-flex flex-column flex-column-fluid"
          id="kt_content"
        >
          <div id="kt_content_container" className="container-fluid">
            <div className="row g-5 g-xxl-10 counters">
              <div className="col-xl-5 col-xxl-3 mb-xl-5 mb-xxl-10">
                <Link to="/orders" className="report-card">
                  <div className="border border-gray-300 border-dashed bg-light-warning rounded min-w-125px py-8 px-2 mb-3">
                    <Counters
                      currency="$"
                      count={
                        allReports?.totalAmountsofOrders
                          ? allReports?.totalAmountsofOrders
                          : 0
                      }
                      CountName="Total Earnings"
                      image={
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="14"
                          height="14"
                          fill="#f06445"
                          className="bi bi-bar-chart"
                          viewBox="0 0 16 16"
                        >
                          <path d="M4 11H2v3h2v-3zm5-4H7v7h2V7zm5-5v12h-2V2h2zm-2-1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1h-2zM6 7a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7zm-5 4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-3z" />
                        </svg>
                      }
                    />
                  </div>
                </Link>
              </div>
              <div className="col-xl-5 col-xxl-3 mb-xl-5 mb-xxl-10">
                <Link to="/manage-membership" className="report-card">
                  <div className="border border-gray-300 border-dashed bg-light-primary rounded min-w-125px py-8 px-2 mb-3">
                    <Counters
                      count={
                        allReports?.membership ? allReports?.membership : 0
                      }
                      CountName="Total Memberships"
                      image={
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="#4fc9da"
                          className="bi bi-person"
                          viewBox="0 0 16 16"
                        >
                          <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z" />
                        </svg>
                      }
                    />
                  </div>
                </Link>
              </div>
              <div className="col-xl-5 col-xxl-3 mb-xl-5 mb-xxl-10">
                <Link to="/manage-fleet" className="report-card">
                  <div className="border border-gray-300 border-dashed bg-light-success rounded min-w-125px py-8 px-2 mb-3">
                    <Counters
                      count={allReports?.fleet ? allReports?.fleet : 0}
                      CountName="Total Fleets"
                      image={
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="#b8d935"
                          className="bi bi-truck"
                          viewBox="0 0 16 16"
                        >
                          <path d="M0 3.5A1.5 1.5 0 0 1 1.5 2h9A1.5 1.5 0 0 1 12 3.5V5h1.02a1.5 1.5 0 0 1 1.17.563l1.481 1.85a1.5 1.5 0 0 1 .329.938V10.5a1.5 1.5 0 0 1-1.5 1.5H14a2 2 0 1 1-4 0H5a2 2 0 1 1-3.998-.085A1.5 1.5 0 0 1 0 10.5v-7zm1.294 7.456A1.999 1.999 0 0 1 4.732 11h5.536a2.01 2.01 0 0 1 .732-.732V3.5a.5.5 0 0 0-.5-.5h-9a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .294.456zM12 10a2 2 0 0 1 1.732 1h.768a.5.5 0 0 0 .5-.5V8.35a.5.5 0 0 0-.11-.312l-1.48-1.85A.5.5 0 0 0 13.02 6H12v4zm-9 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm9 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2z" />
                        </svg>
                      }
                    />
                  </div>
                </Link>
              </div>
              <div className="col-xl-5 col-xxl-3 mb-xl-5 mb-xxl-10">
                <Link to="/manage-customers" className="report-card">
                  <div className="border border-gray-300 border-dashed rounded bg-light-danger min-w-125px py-8 px-2 mb-3">
                    <Counters
                      count={allReports?.user ? allReports?.user : 0}
                      CountName="Total Customers"
                      image={
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="#ff0000"
                          className="bi bi-people"
                          viewBox="0 0 16 16"
                        >
                          <path d="M15 14s1 0 1-1-1-4-5-4-5 3-5 4 1 1 1 1h8zm-7.978-1A.261.261 0 0 1 7 12.996c.001-.264.167-1.03.76-1.72C8.312 10.629 9.282 10 11 10c1.717 0 2.687.63 3.24 1.276.593.69.758 1.457.76 1.72l-.008.002a.274.274 0 0 1-.014.002H7.022zM11 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm3-2a3 3 0 1 1-6 0 3 3 0 0 1 6 0zM6.936 9.28a5.88 5.88 0 0 0-1.23-.247A7.35 7.35 0 0 0 5 9c-4 0-5 3-5 4 0 .667.333 1 1 1h4.216A2.238 2.238 0 0 1 5 13c0-1.01.377-2.042 1.09-2.904.243-.294.526-.569.846-.816zM4.92 10A5.493 5.493 0 0 0 4 13H1c0-.26.164-1.03.76-1.724.545-.636 1.492-1.256 3.16-1.275zM1.5 5.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0zm3-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4z" />
                        </svg>
                      }
                    />
                  </div>
                </Link>
              </div>
            </div>
            <div className="row g-5 g-xxl-10">
              <div className="col-xl-12 col-xxl-12 mb-5 mb-xxl-4">
                <div
                  id="kt_datatable_example_5_wrapper"
                  className="dataTables_wrapper dt-bootstrap4 no-footer"
                >
                  <div className="table-responsive table-wrapper">
                    <h2 className="d-flex flex-column text-dark fw-bolder fs-2 mb-8">
                      Service Requests
                    </h2>
                    <table
                      id="kt_datatable_example_5"
                      className="table table-striped table-row-bordered gy-5 gs-7 border rounded dataTable no-footer btn-status"
                    >
                      <thead>
                        <tr className="fw-bolder fs-6 text-gray-800 px-7 arrow-none">
                          <th style={{ width: "94.062px" }}>SR No.</th>
                          <th style={{ width: "115.547px" }}>Customer Name</th>
                          {/* <th style={{ width: "127.094px" }}>
                              Membership Status
                            </th> */}
                          {/* <th style={{ width: "127.8594px" }}>Date</th> */}
                          <th style={{ width: "128.172px" }}>Staff Assigned</th>
                          <th style={{ width: "128.172px" }}>Fleet Assigned</th>

                          {/* <th style={{ width: "122.984px" }}>
                            Requested Service
                          </th> */}
                          <th style={{ width: "149.609px" }}>Order Status</th>
                          <th style={{ width: "155.172px" }}>Work status</th>
                          <th style={{ width: "170px" }}></th>
                        </tr>
                      </thead>
                      <tbody>
                        {!loading && recentOrder?.[0]?._id ? (
                          recentOrder?.map((item, index) => {
                            // console.log(item, "item");
                            return (
                              <tr key={index}>
                                <td>{item.invoice_no}</td>
                                <td>
                                  {`${
                                    item.customer_id?.firstName
                                      ? item.customer_id?.firstName
                                      : ""
                                  } ${
                                    item.customer_id?.lastName
                                      ? item.customer_id?.lastName
                                      : ""
                                  }`}{" "}
                                </td>
                                {/* <td>{item.customer_id?.status}</td> */}
                                {/* <td>
                                  {recentOrder?.[0]?._id
                                    ? dateFormat(
                                        item?.createdAt,
                                        "d mmmm , yyyy, hh:mm:ss"
                                      )
                                    : "N/A"}
                                </td> */}
                                <td>
                                  {item?.staffs_id?.firstName
                                    ? item?.staffs_id?.firstName +
                                      " " +
                                      item?.staffs_id?.lastName
                                    : "N/A"}
                                </td>
                                <td>
                                  {item?.fleet_id?.name
                                    ? item?.fleet_id?.name
                                    : "N/A"}
                                </td>

                                <td>
                                  <span
                                    className={`badge ${recentOrderColor(
                                      item?.status
                                    )}`}
                                  >
                                    {recentOrderStatus(item?.status)}
                                  </span>
                                </td>
                                <td>
                                  <span
                                    className={`badge ${taskStatusColor(
                                      item?.task_status
                                    )}`}
                                  >
                                    {taskStatus(item?.task_status)}
                                  </span>
                                </td>
                                <td style={{ width: "200px" }}>
                                  <RecentOrderView
                                    modalId={"exampleModal"}
                                    id={id ? id : ""}
                                  />
                                  <Link
                                    to={`/order-detail/${item.id}`}
                                    className="btn btn-bg-primary action-hover"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="16"
                                      height="16"
                                      fill="currentColor"
                                      className="bi bi-eye-fill"
                                      viewBox="0 0 16 16"
                                    >
                                      <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z" />
                                      <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z" />
                                    </svg>
                                  </Link>
                                  <Link
                                    to={`/edit-order/${item?.id}`}
                                    onClick={() => setId(item?.id)}
                                    className="btn btn-info action-hover"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="16"
                                      height="16"
                                      fill="currentColor"
                                      className="bi bi-pencil-square"
                                      viewBox="0 0 16 16"
                                    >
                                      <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                                      <path
                                        fillRule="evenodd"
                                        d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
                                      />
                                    </svg>
                                  </Link>
                                  <Link
                                    to="/dashboard"
                                    onClick={() => recentDel(item?.id)}
                                    className="btn btn-bg-dark action-hover"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="16"
                                      height="16"
                                      fill="currentColor"
                                      className="bi bi-trash-fill"
                                      viewBox="0 0 16 16"
                                    >
                                      <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z" />
                                    </svg>
                                  </Link>
                                  <Link
                                    to="#"
                                    onClick={() => 
                                      {setCancelOrderId(item.id);
                                      setOData(item);}
                                    }
                                    className="btn btn-bg-danger action-hover"
                                    data-bs-toggle="modal"
                                    data-bs-target="#orderCancel"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="16"
                                      height="16"
                                      fill="currentColor"
                                      className="bi bi-x-circle-fill"
                                      viewBox="0 0 16 16"
                                    >
                                      <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM4.646 4.646a.5.5 0 0 0-.708.708L7.293 8 3.938 11.354a.5.5 0 1 0 .708.708L8 8.707l3.354 3.355a.5.5 0 0 0 .708-.708L8.707 8l3.355-3.354a.5.5 0 0 0-.708-.708L8 7.293 4.646 4.646z" />
                                    </svg>
                                  </Link>
                                  <CancelOrder modalId={"orderCancel"} id={cancelOrderId} data={oData}/>
                                </td>
                              </tr>
                            );
                          })
                        ) : loading ? (
                          <div className="spinner-outer p-5">{loader()}</div>
                        ) : (
                          recentOrder?.length === 0 && (
                            <div className="spinner-outer p-5">
                              <p>Data not found</p>
                            </div>
                          )
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div className="col-xl-12 col-xxl-12 mb-5 mb-xxl-4">
                <div className="d-flex justify-content-between">
                  <h2 className="d-flex flex-column text-dark fw-bolder fs-2 mb-8">
                    Contact Form Leads
                  </h2>
                  {/* <CSVLink
                    data={messageList}
                    headers={headers}
                    className="csvlink"
                  >
                    Download Report
                  </CSVLink> */}
                </div>

                <div className="table-responsive table-wrapper">
                  <table
                    id="kt_datatable_example_5"
                    className="table table-striped table-row-bordered gy-5 gs-7 border rounded dataTable no-footer"
                  >
                    <thead>
                      <tr className="fw-bolder fs-6 text-gray-800 px-7 arrow-none">
                        <th className="text-start">Name</th>
                        <th></th>
                        <th></th>
                        <th className="text-start">Email Address</th>
                        <th></th>
                        <th></th>
                        <th className="text-start">Phone Number</th>
                        <th></th>
                        <th></th>
                        <th className="text-start">Message</th>
                      </tr>
                    </thead>
                    <tbody>
                      {productDataList?.length ? (
                        productDataList?.map((item, index) => {
                          return (
                            <tr key={index}>
                              <td className="text-start">{item?.name}</td>
                              <td></td>
                              <td></td>
                              <td className="text-start">{item?.email}</td>
                              <td></td>
                              <td></td>
                              <td className="text-start">{item?.phone}</td>
                              <td></td>
                              <td></td>
                              <td className="text-start">{item?.message}</td>
                            </tr>
                          );
                        })
                      ) : loading ? (
                        <div className="spinner-outer p-5">{loader()}</div>
                      ) : (
                        productDataList?.length === 0 && (
                          <p style={{ margin: "14px 22px" }}>No Data Found</p>
                        )
                      )}
                    </tbody>
                  </table>
                </div>
                <Pagination
                  pageSize={10}
                  items={contact?.data?.contact}
                  onChangePage={onChangePage}
                />
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </React.Fragment>
  );
};

// const mapStateToProps = (state) => ({
//   loadingOrder: state?.order?.loading,
//   recentOrdersList:state?.order?.new_orders,
//   OrdersNotFound:state?.order?.not_found
// });

export default connect(null, {
  reportList,
  recentOrders,
  ordersList,
})(Dashboard);
